<template>
	<div class="m-list-product-info">
		<p class="product-name">
			<c-state v-if="level" tag dict="LEVEL_TYPE" :value="level"></c-state>
			<span>{{name || '-'}}</span>
		</p>
		<p class="product-code">背贴码：{{code || '-'}} <c-link v-if="code" color="gray" @click="$copy(code)"><i class="tf">&#xe6b0;</i></c-link></p>
		<p class="product-code">IMEI：{{imei || '-'}} <c-link v-if="imei" color="gray" @click="$copy(imei)"><i class="tf">&#xe6b0;</i></c-link>
            <c-tooltip v-if="oldImei" :tip="'原IMEI：' + oldImei"><span class="m-help">!</span></c-tooltip>
        </p>
	</div>
</template>

<script>
	export default {
		name: 'mProductInfo',
		props: {
			name: String,
			level: [Number, String],
			code: String,
			imei: String,
			/*首次改串号时留存的原始号：不传则不渲染感叹号提示，不影响其余使用方*/
			oldImei: String
		}
	}
</script>

<style lang="stylus" scoped>
	.m-list-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		p {
			margin: 0;
		}

		.product-name {
			display: flex;
			align-items: center;
			gap: 4px;

			.c-state {
				flex-shrink: 0;
			}
		}

		.product-code {
			color: #999;
			font-size: 12px;
			white-space: nowrap;
		}

		/* 与 price_edit_dialog.vue 的 .m-help 同款：行内文本需要 vertical-align 才能与 24px 行高对齐；
		   配色取 #e6a23c，与 sales 各弹框的告警黄一致 */
		.m-help {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 14px;
			height: 14px;
			margin-left: 4px;
			border: 1px solid #e6a23c;
			border-radius: 50%;
			font-size: 10px;
			color: #e6a23c;
			cursor: pointer;
			vertical-align: middle;
		}
	}
</style>
